import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/Part5Selection.css";
import { useSubscriptionStatus } from "../../../hooks/useSubscriptionStatus";
import { freeContent } from "../../../utils/freeContent";

const Part5Selection = ({ isActive, onCategorySelect, onBack }) => {
  const navigate = useNavigate();
  const categories = [
    { id: 3, title: "1. 빈칸훈련", path: "blank-training" },
    { id: 2, title: "2. 문장훈련", path: "parts-of-speech" },
    { id: 1, title: "3. 문제풀이", path: "grammar" },
  ];

  useEffect(() => {
    const savedCategory = window.localStorage.getItem("part5SelectedCategory");
    if (savedCategory) {
      window.localStorage.removeItem("part5SelectedCategory");
      handleCategoryClick(savedCategory);
    }
  }, []);

  const handleCategoryClick = (path) => {
    // 구독자인 경우 모든 컨텐츠에 접근 가능
    if (isActive) {
      onCategorySelect(path);
      return;
    }

    // 비구독자인 경우 무료 컨텐츠 체크
    const freeCategories = freeContent.part5.categories || [];
    const isFreeContent = freeCategories.includes(path);

    if (!isFreeContent) {
      // 구독 모달 표시 로직 추가 필요
      return;
    }

    onCategorySelect(path);
  };

  return (
    <div className="part5-selection">
      <h2>Part 5 - Select Category</h2>
      <div className="category-grid">
        {categories.map((category) => {
          const freeCategories = freeContent.part5.categories || [];
          const isFreeContent = freeCategories.includes(category.path);

          return (
            <div
              key={category.id}
              className={`category-card ${
                !isActive && !isFreeContent ? "premium" : ""
              }`}
              onClick={() => handleCategoryClick(category.path)}
            >
              <h3>{category.title}</h3>
              {!isActive && !isFreeContent && (
                <div className="lock-overlay">
                  <img src="/icons/lock.svg" alt="잠김" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Part5Selection;
